/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsfilterpast2Inputs */

const en_earningsfilterpast2 = /** @type {(inputs: Earningsfilterpast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past`)
};

const de_earningsfilterpast2 = /** @type {(inputs: Earningsfilterpast2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene`)
};

/**
* | output |
* | --- |
* | "Past" |
*
* @param {Earningsfilterpast2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfilterpast2 = /** @type {((inputs?: Earningsfilterpast2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfilterpast2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfilterpast2(inputs)
	return de_earningsfilterpast2(inputs)
});
export { earningsfilterpast2 as "earningsFilterPast" }